import styled from 'styled-components';

// The real card is 104 px tall with 13 px 16 px 13 px 27 px padding (measured on dev, 21 Oct 2026).
const TINT = '#f3f5f7';
const BAR = '#e5e9ed';

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
  height: 104px;
  padding: 13px 16px 13px 27px;
  background-color: ${TINT};
`;

export const TitleBar = styled.div`
  width: 55%;
  height: 18px;
  border-radius: 4px;
  background: ${BAR};
`;

export const DetailBar = styled.div`
  width: 35%;
  height: 14px;
  border-radius: 4px;
  background: ${BAR};
`;
